import React, { ReactNode } from 'react'
import classNames from 'classnames'
import RadioCheckedSvg from '../../public/svgs/radio-checked.svg'
import RadioBlankSvg from '../../public/svgs/radio-blank.svg'

type RadioButtonProps = {
  checked?: boolean
  onCheck?: (checked: boolean) => void
  className?: string
  styleName?: string
}

export const RadioButton = ({
  checked,
  onCheck,
  className = undefined,
}: RadioButtonProps) => (
  <div className="flex items-center">
    <img
      className="flex-shrink-0 w-4 h-4 sp:w-[4.27vw] sp:h-[4.27vw]"
      width={16}
      height={16}
      onClick={onCheck !== undefined ? () => onCheck(!checked) : undefined}
      src={checked ? RadioCheckedSvg.src : RadioBlankSvg.src}
    />
  </div>
)

type Props = {
  id?: string
  checked: boolean
  label: string
  onCheck: (checked: boolean) => void
  widthType?: 's' | 'm' | 'l'
  className?: string
  'data-value'?: string
  isRecommended?: boolean
  description?: ReactNode
}

export const RadioCard = ({
  id,
  label,
  checked,
  onCheck,
  widthType = 'm',
  'data-value': dataAttribute,
  description,
  className,
}: Props) => (
  <div
    id={id}
    className={classNames(
      className,
      'bg-white transition-all duration-200 ease-linear text-left border-2 border-border-gray-0 box-border rounded cursor-pointer font-yu-gothic font-bold desktop:min-w-[160px] desktop:p-5 desktop:min-h-[152px] sp:py-[4.27vw] sp:px-[3.2vw] sp:pl-[5.33vw]',
      {
        'bg-bg-gray-0 border-primary': checked,
      }
    )}
    onClick={() => onCheck(!checked)}
    data-value={dataAttribute}
  >
    <div className="relative flex items-center">
      <div className="desktop:mr-4 sp:mr-[5.33vw]">
        <RadioButton checked={checked} onCheck={onCheck} />
      </div>
      {label}
    </div>
    {description && (
      <div className="text-left text-text-black font-normal mt-2 whitespace-pre-line">
        {description}
      </div>
    )}
  </div>
)
